import i18n from "i18next";
import frTranslation from "./languages/fr.json";
import enTranslation from "./languages/en.json";
import deTranslation from "./languages/de.json";
import zhTwTranslation from "./languages/zh-tw.json";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
            },
            fr: {
                translation: frTranslation,
            },
            de: {
                translation: deTranslation,
            },
            "zh-TW": {
                translation: zhTwTranslation,
            },
        },
        lng: localStorage.getItem("locale") || "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        nonExplicitSupportedLngs: true,
    });

export default i18n;
